export default "__VITE_ASSET__C6mV7gDX__"